export const SECRET_KEY = 'MkH0uqUMT8umHwi9SPfu/LGRBHiqsLHTi8rKOS3bN90=';